import AdaptiveTabs from 'components/AdaptiveTabs/AdaptiveTabs'
import { StyledTab } from 'components/StyledTab/StyledTab'
import TabPanel from 'components/TabPanel/TabPanel'
import { useUrlQueryState } from 'hooks/useUrlQueryState'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectStation } from 'store/selectors/station'
import { parseStationTab, serializeStationTab } from 'utils/urlViewParams'
import { getStationFeedbackStatus, stationFeedbackTitle } from 'utils/stationFeedback'

import EventsLog from './EventsLog/EventsLog'
import StationControl from './StationControl/StationControl'
import StationDetails from './StationDetails/StationDetails'

const tabSx = {
  fontSize: 16,
  fontWeight: '400',
  textTransform: 'none' as const,
  letterSpacing: 0,
  padding: '12px 10px',
}

/** Status=0, Control=1, History=2 */
const TAB_STATUS = 0
const TAB_CONTROL = 1
const TAB_HISTORY = 2

const StationLeftBlock = () => {
  const station = useSelector(selectStation)
  const feedback = getStationFeedbackStatus(station)
  const disableTelemetryTabs = feedback === 'no_feedback'
  const [url, setUrl] = useUrlQueryState({
    tab: {
      parse: parseStationTab,
      serialize: serializeStationTab,
    },
  })
  const tab = url.tab
  const setTab = (value: number) => setUrl({ tab: value })

  useEffect(() => {
    if (disableTelemetryTabs && (tab === TAB_CONTROL || tab === TAB_HISTORY)) {
      setTab(TAB_STATUS)
    }
  }, [disableTelemetryTabs, tab])

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    if (disableTelemetryTabs && (newValue === TAB_CONTROL || newValue === TAB_HISTORY)) {
      return
    }
    setTab(newValue)
  }

  const telemetryTabTitle = disableTelemetryTabs ? stationFeedbackTitle(feedback) : undefined

  return (
    <div className="flex-column">
      <AdaptiveTabs
        value={tab}
        onChange={handleChange}
        indicatorColor="primary"
        sx={{ height: 45, minHeight: 45 }}
      >
        <StyledTab label="Status" sx={tabSx} disableRipple />
        <StyledTab
          label="Control"
          sx={tabSx}
          disableRipple
          disabled={disableTelemetryTabs}
          title={telemetryTabTitle}
        />
        <StyledTab
          label="History"
          sx={tabSx}
          disableRipple
          disabled={disableTelemetryTabs}
          title={telemetryTabTitle}
        />
      </AdaptiveTabs>
      <TabPanel value={tab} index={TAB_STATUS} disablePadding={true} scrollable={true}>
        <StationDetails />
      </TabPanel>
      <TabPanel value={tab} index={TAB_CONTROL} disablePadding={true} scrollable={true}>
        <StationControl />
      </TabPanel>
      <TabPanel value={tab} index={TAB_HISTORY} disablePadding={true} scrollable={false}>
        <EventsLog />
      </TabPanel>
    </div>
  )
}

export default StationLeftBlock
